import { theme } from '@/theme'

export const config = {
  title: 'DevOps and cloud\ncomputing',
  subtitle:
    'Hire expertised Cloud engineers to uncover an agile path to successful software development. Discover cutting-edge solutions to ensure the security, automation, scalability, and unparalleled growth of your business.',
  imagePath: '/images/devops-big-logo.webp',
  imageAlt: 'DevOps and cloud computing services',
  imageTitle: 'DevOps and cloud computing services',
  imageWidth: '508',
  imageHeight: '385',
  textColor: `${theme.colors.milkyWhite}`,
  background: `${theme.colors.gradientGray}`,
  indexMarginTop: `${theme.spaces[3]}px`,
  imageRight: -150,
}
